/**
 * Created by noOne on 15/02/2018.
 */
"use strict";

export default class StackedSprite extends PIXI.Container {
    constructor() {
        super();

        //   this._stackHeight = 12;

        this._layers = [];

        // this.scale.set(2);
        const t = Common.assets.texture;
        // grab textures from sheet and pop them into a convenient array where they can be accessed using the tile id as the index
        let sheet = t("cube").baseTexture;
        sheet.scaleMode = PIXI.SCALE_MODES.NEAREST;
        let textures = [];
        let total = sheet.width / 32;
        //let tilesPerCol = sheet.height / Common.tileSize;
        // let totalTileTextures = 21;
        for (let i = 0; i < total; i++) {
            textures.push(new PIXI.Texture(sheet, new PIXI.Rectangle(Math.round(i * 32), 0, 32, 32)));
        }

        this._textures = textures;

        this.init();
    }

    init() {

        const t = Common.assets.texture;
        for (let i = 0; i <= this._textures.length; i++) {
            //  let sp = P3.utils.sprite(t("iso_" + i), this, new PIXI.Point(0.5, 0.5));
            let sp = new PIXI.Sprite(this._textures[i]); //new PIXI.extras.TilingSprite(t("dirt_strip"), 32, 32);
            //sp.width = 16;
            sp.anchor.set(0.5);
            // sp.tilePosition.x = Math.round(Math.random() * 32);
            // sp.tilePosition.y = Math.round(Math.random() * 32);
            sp.y = -i * 4;
            sp.scale.set(2);

            // if (Math.random() < 0.5) sp.scale.x = -sp.scale.x;
            //  if (Math.random() < 0.5) sp.scale.y = -sp.scale.y;

            this._layers.push(sp);
            this.addChild(sp);
        }

        // this.scale.set(4);

        //  if (!isPyramid) {
        /*
         let sp = P3.utils.sprite(t("dirt_top"), this, new PIXI.Point(0.5, 0.5));
         sp.y = -25;
         this._layers.push(sp);

         sp.scale.set(2);
         */
        //  }

    }

    update(dir) {
        for (let i = 0; i < this._layers.length; i++) {
            this._layers[i].rotation += deltaTime * dir;
        }
    }
}